import Swiper, { Navigation } from "swiper"
import gsap from "gsap"

class About {
  constructor() {
    if (document.querySelector(".about")) {
      this.About()
    }
  }

  About() {
    this.peopleCollapsed = true

    Swiper.use([Navigation])
    new Swiper(".aboutWith__swiper", {
      navigation: {
        nextEl: ".aboutWith__next",
        prevEl: ".aboutWith__prev",
      },
      watchSlidesProgress: true,
      slidesPerView: 1.4,
      spaceBetween: 20,
      breakpoints: {
        763: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      },
    })

    document
      .querySelector(".aboutHelpPeople__showMore")
      .addEventListener("click", () => {
        if (!this.peopleCollapsed) return
        this.expandPeople()
      })

    this.width = window.innerWidth
    window.addEventListener("resize", () => {
      this.resized()
    })
    this.resized()
  }

  resized() {
    const w = window.innerWidth
    if (w != this.width) {
      if (w <= 736) {
        if (!this.peopleCollapsed) {
          this.collapsePeople()
        }
      } else {
        if (this.peopleCollapsed) {
          this.expandPeople()
        }
      }

      this.width = w
    }
  }

  collapsePeople() {
    this.peopleCollapsed = true

    document.querySelector(".aboutHelpPeople__showMore").style.display = "block"
    gsap.to(document.querySelector(".aboutHelpPeople__showMore"), {
      opacity: 1,
      duration: 0.35,
    })

    document.querySelector(".aboutHelpPeople__mask").style.display = "block"
    gsap.to(document.querySelector(".aboutHelpPeople__mask"), {
      opacity: 1,
      duration: 0.35,
    })

    const h = document.querySelector(".aboutHelpPeople__list").scrollHeight
    document.querySelector(".aboutHelpPeople__list").style.height = h
    gsap.to(document.querySelector(".aboutHelpPeople__list"), {
      height: 380,
      duration: 0.35,
    })
  }

  expandPeople() {
    this.peopleCollapsed = false

    gsap.to(document.querySelector(".aboutHelpPeople__showMore"), {
      opacity: 0,
      duration: 0.35,
      onComplete: () => {
        document.querySelector(".aboutHelpPeople__showMore").style.display =
          "none"
      },
    })

    gsap.to(document.querySelector(".aboutHelpPeople__mask"), {
      opacity: 0,
      duration: 0.35,
      onComplete: () => {
        document.querySelector(".aboutHelpPeople__mask").style.display = "none"
      },
    })

    const h = document.querySelector(".aboutHelpPeople__list").scrollHeight
    gsap.to(document.querySelector(".aboutHelpPeople__list"), {
      height: h,
      duration: 0.35,
      onComplete: () => {
        document.querySelector(".aboutHelpPeople__list").style.height = "auto"
      },
    })
  }
}

export default About
